import { render } from "./IndexTariffsPage.vue?vue&type=template&id=3ae77069"
import script from "./IndexTariffsPage.vue?vue&type=script&lang=js"
export * from "./IndexTariffsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__